import type { ReactNode } from "react";
import { toast } from "sonner";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TUndoToastProps = {
  message: ReactNode;
  onUndo: () => void;
  undoLabel?: string;
  className?: string;
};

export function UndoToast({ message, onUndo, undoLabel = "Undo", className }: TUndoToastProps) {
  return (
    <div
      data-testid="undo-toast"
      className={cn(
        "flex w-[356px] max-w-[calc(100vw-2rem)] items-center gap-4 rounded-lg border border-zinc-150 bg-white p-4 shadow-md",
        className
      )}
    >
      <p className="min-w-0 flex-1 break-words text-[12px] leading-[18px] font-medium text-zinc-900">{message}</p>
      <button
        type="button"
        onClick={onUndo}
        className="flex h-6 shrink-0 items-center justify-center rounded-md border border-zinc-150 px-2 text-[12px] font-medium leading-none text-zinc-900 transition-colors hover:bg-zinc-50"
      >
        {undoLabel}
      </button>
    </div>
  );
}

type TShowUndoToastParams = {
  message: ReactNode;
  onUndo: () => void;
  undoLabel?: string;
  duration?: number;
};

export function showUndoToast({ message, onUndo, undoLabel, duration = 5000 }: TShowUndoToastParams) {
  return toast.custom(
    (id) => (
      <UndoToast
        message={message}
        undoLabel={undoLabel}
        onUndo={() => {
          onUndo();
          toast.dismiss(id);
        }}
      />
    ),
    { duration, unstyled: true }
  );
}
